import React, { Component } from 'react'
import { connect } from 'react-redux'
import {
  getTranslation,
  getPages,
  getToken,
  getElements,
  getTotalPages,
  getActualPage,
  getLastPagePosition,
  getActualPageIndex
} from '@/store/getters'
import {
  showFileManager,
  setLockBackground,
  clonePage,
  updatePage,
  showAlert,
  closeAlert,
  removePage,
  toggleToaster,
  setElements,
  setActivePage,
  setActiveElement,
} from '@/store/actions'
import { MagazineConsumer } from '@/contexts/magazine'

import styles from './styles.scss'

/** Componentes */
import IconComponent from '@/components/commons/IconComponent'
import { PopOver } from '@/components/commons/PopOver'
import { togglePageOrder } from '../../../../store/actions/ui'
import ColorPicker from '../../../../components/ColorPicker/index'

class PageActions extends Component {
  state = {
    openNavigation: true,
    showPalette: false,
  }

  static contextType = MagazineConsumer;

  handleAdd = () => {
    const { setActiveElement, toggleToaster, translation } = this.props
    const { onAddPage } = this.context

    setActiveElement(null)
    toggleToaster({
      isVisible: true,
      message: translation('page-add-toast-message'),
      position: 'top-right',
      type: 'success'
    })
    onAddPage()
  }

  handleDuplicate = () => {
    const {
      actualPage,
      lastPagePosition: page_position,
      translation,
      clonePage,
      showAlert,
      closeAlert,
      toggleToaster,
      setActiveElement
    } = this.props

    const { id } = actualPage

    showAlert({
      title: translation('pages-duplicate-title'),
      message: translation('pages-duplicate-message'),
      hasCancel: true,
      callback: () => {
        setActiveElement(null)
        clonePage(id, { page_position })
        closeAlert()

        toggleToaster({
          isVisible: true,
          message: translation('page-duplicate-toast-message'),
          position: 'top-right',
          type: 'success'
        })
      }
    })
  }

  handleDelete = () => {
    const {
      actualPage,
      translation,
      removePage,
      showAlert,
      closeAlert,
      toggleToaster,
      setActiveElement
    } = this.props

    const { id } = actualPage

    showAlert({
      title: translation('pages-remove-title'),
      message: translation('general-delete-message'),
      type: 'error',
      hasCancel: true,
      callback: () => {
        setActiveElement(null)
        removePage(id)
        closeAlert()
        toggleToaster({
          isVisible: true,
          message: translation('page-removed-toast-message'),
          position: 'top-right',
          type: 'error'
        })
      }
    })
  }

  handleFirst = () => {
    const {
      setElements,
      setActiveElement,
      setActivePage,
      pages,
      elements,
      actualPage,
      token,
      updatePage
    } = this.props

    actualPage.items = elements;

    updatePage({
      pageItem: actualPage,
      accessToken: token
    })

    const page = pages[0]
    setActiveElement(null)
    setActivePage(page)
    setElements(page.items)
  }

  handlePrevious = () => {
    const {
      actualPageIndex,
      setElements,
      setActiveElement,
      setActivePage,
      pages,
      elements,
      actualPage,
      token,
      updatePage
    } = this.props

    if (!!actualPageIndex) {
      actualPage.items = elements;
      updatePage({
        pageItem: actualPage,
        accessToken: token
      })

      const pageIndex = actualPageIndex - 1
      const page = pages[pageIndex]
      setActiveElement(null)
      setActivePage(page)
      setElements(page.items)
    }
  }

  handleNext = () => {
    const {
      actualPageIndex,
      setElements,
      setActiveElement,
      setActivePage,
      pages,
      elements,
      actualPage,
      token,
      updatePage
    } = this.props

    const pageIndex = actualPageIndex + 1

    if (pageIndex < pages.length) {
      actualPage.items = elements;
      updatePage({
        pageItem: actualPage,
        accessToken: token
      })

      const page = pages[pageIndex]
      setActiveElement(null)
      setActivePage(page)
      setElements(page.items)
    }
  }

  handleLast = () => {
    const {
      setElements,
      setActiveElement,
      setActivePage,
      pages,
      elements,
      actualPage,
      token,
      updatePage
    } = this.props

    actualPage.items = elements;
    updatePage({
      pageItem: actualPage,
      accessToken: token
    })

    const page = pages[pages.length - 1]
    setActiveElement(null)
    setActivePage(page)
    setElements(page.items)
  }

  handleSpecificPage = (pageIndex) => {
    const {
      setElements,
      setActiveElement,
      setActivePage,
      pages,
      elements,
      actualPage,
      token,
      updatePage
    } = this.props

    if (pageIndex < pages.length) {
      actualPage.items = elements;
      updatePage({
        pageItem: actualPage,
        accessToken: token
      })

      const page = pages[pageIndex - 1]
      setActiveElement(null)
      setActivePage(page)
      setElements(page.items)
    }
  }

  handleBackgroundColor = (color) => {
    const { actualPage, token, updatePage } = this.props

    const { backgroundImage, ...rest } = actualPage.properties || {}
    actualPage.properties = {
      ...rest,
      backgroundColor: color
    }

    updatePage({
      pageItem: actualPage,
      accessToken: token
    })
  }

  handleBackgroundImage = (image) => {
    const { actualPage, setActivePage, token, updatePage } = this.props
    actualPage.properties = {
      ...actualPage.properties,
      backgroundImage: `url(${image})`,
      backgroundSize: 'cover'
    }

    setActivePage(actualPage)
    updatePage({
      pageItem: actualPage,
      accessToken: token
    })
  }

  handleOpenFileManager = () => {
    this.props.showFileManager({
      isOpened: true,
      callback: this.handleBackgroundImage
    })
    this.props.setLockBackground({ isVisible: true })
  }

  render() {
    const { showPalette } = this.state
    const { translation, totalPages, actualPageIndex, actualPage, togglePageOrder } = this.props

    var backgroundColor = actualPage.properties || {}

    // var backgroundColor = {}

    // setTimeout(() => {
    //   backgroundColor = this.props.actualPage.properties || {}
    // }, 1000);

    return (
      <React.Fragment>
        <div className={styles['navegate-menu']}>
          <button className='ba-btn ba-btn-normal ba-sm ba-rounded' onClick={this.handleFirst}
            tooltip={translation('general-first-page')}
            tooltip-position="bottom">
            <IconComponent icon="double-left-arrow" />
          </button>
          <button className='ba-btn ba-btn-normal ba-sm ba-rounded' onClick={this.handlePrevious}
            tooltip={translation('general-previous-page')}
            tooltip-position="bottom">
            <IconComponent icon="new-left-arrow" />
          </button>
          <input type="number" className={'ba-input ba-text-center ' + styles['montserrat']}
            placeholder={'Page ' + (actualPageIndex + 1) + '/' + totalPages}
            onChange={(e) => this.handleSpecificPage(e.target.value)} />
          <button className='ba-btn ba-btn-normal ba-sm ba-rounded' onClick={this.handleNext}
            tooltip={translation('general-next-page')}
            tooltip-position="bottom">
            <IconComponent icon="new-right-arrow" />
          </button>
          <button className='ba-btn ba-btn-normal ba-sm ba-rounded' onClick={this.handleLast}
            tooltip={translation('general-last-page')}
            tooltip-position="bottom">
            <IconComponent icon="double-right-arrow" />
          </button>
          <div className={styles['navegate-menu__vertical-line']}></div>
          <button className='ba-btn ba-btn-normal ba-sm ba-rounded'
            onClick={() =>
              togglePageOrder({
                isOpened: true
              })
            }
            tooltip={translation('general-page-order')}
            tooltip-position="bottom">
            <IconComponent icon="library" />
          </button>
          <button className='ba-btn ba-btn-normal ba-sm ba-rounded' onClick={this.handleAdd}
            tooltip={translation('editor-button-add-page')}
            tooltip-position="bottom">
            <IconComponent icon="new-page" />
          </button>
          <button className='ba-btn ba-btn-normal ba-sm ba-rounded' onClick={() => this.setState({ showPalette: !showPalette })}
            tooltip={translation('general-background-color')}
            tooltip-position="bottom">
            <IconComponent icon="paint" />
          </button>
          <button className='ba-btn ba-btn-normal ba-sm ba-rounded' onClick={this.handleOpenFileManager}
            tooltip={translation('general-background-image')}
            tooltip-position="bottom">
            <builderall-icon code='fc98'></builderall-icon>
          </button>
          {
            totalPages > 1 && (
              <button className='ba-btn ba-btn-trash ba-sm ba-rounded' onClick={this.handleDelete}
                tooltip={translation('pages-remove-title')}
                tooltip-position="bottom">
                <builderall-icon code='trash' />
              </button>
            )
          }
          {/* <nav className={''}>
            <ul>
              <li
                tooltip={translation('editor-button-add-page')}
                tooltip-position="left"
                data-ba-i="magazine-page-add"
                aria-hidden={true}
                onClick={this.handleAdd}
              >
                <IconComponent icon="page-add" />
              </li>
              <li
                tooltip={translation('pages-duplicate-title')}
                tooltip-position="left"
                data-ba-i="magazine-page-duplicate"
                aria-hidden={true}
                onClick={this.handleDuplicate}
              >
                <IconComponent icon="page-duplicate" />
              </li>
              <li
                tooltip={translation('general-previous-page')}
                tooltip-position="left"
                data-ba-i="magazine-previous-page"
                aria-hidden={true}
                onClick={this.handlePrevious}
              >
                <IconComponent icon="left-arrow" />
              </li>
              <li
                tooltip={translation('general-next-page')}
                tooltip-position="left"
                data-ba-i="magazine-next-page"
                aria-hidden={true}
                onClick={this.handleNext}
              >
                <IconComponent icon="right-arrow" />
              </li>
              <li
                tooltip={translation('general-background-color')}
                tooltip-position="left"
                data-ba-i="magazine-page-background-color"
                aria-hidden={true}
                onClick={() => this.setState({ showPalette: !showPalette })}
              >
                <IconComponent icon="palette" />
              </li>
              <li
                tooltip={translation('general-background-image')}
                tooltip-position="left"
                data-ba-i="magazine-page-background-image"
                aria-hidden={true}
                onClick={this.handleOpenFileManager}
              >
                <IconComponent icon="image" />
              </li>
              {
                totalPages > 1 && (
                  <li
                    tooltip={translation('pages-remove-title')}
                    tooltip-position="top"
                    data-ba-i="magazine-delete-page"
                    aria-hidden={true}
                    onClick={this.handleDelete}
                  >
                    <IconComponent icon="delete" />
                  </li>
                )
              }
            </ul>
          </nav> */}
          {showPalette && (
            <PopOver
              className={styles['wrapper-page-actions__nav-palette']}
              hidePopover={() => this.setState({ showPalette: false })}
            >
              <ColorPicker
                color={backgroundColor.backgroundColor}
                onChange={({ hex }) => this.handleBackgroundColor(hex)}
              />
            </PopOver>
          )}
        </div>
      </React.Fragment>
    )
  }
}

const mapStateToProps = state => {
  const translation = getTranslation(state)
  const pages = getPages(state)
  const token = getToken(state)
  const elements = getElements(state)
  const totalPages = getTotalPages(state)
  const actualPage = getActualPage(state)
  const lastPagePosition = getLastPagePosition(state)
  const actualPageIndex = getActualPageIndex(state)
  return {
    translation,
    pages,
    token,
    elements,
    totalPages,
    actualPage,
    lastPagePosition,
    actualPageIndex
  }
}
export default connect(
  mapStateToProps,
  {
    showFileManager,
    setLockBackground,
    showAlert,
    updatePage,
    closeAlert,
    clonePage,
    removePage,
    toggleToaster,
    setElements,
    setActivePage,
    setActiveElement,
    togglePageOrder
  }
)(PageActions)



// WEBPACK FOOTER //
// ./src/pages/Editor/components/PageActions/index.js